import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/pages/base.component';

@Component({
  selector: 'app-leave-allotment',
  templateUrl: './leave-allotment.component.html',
  styleUrls: ['./leave-allotment.component.css']
})
export class LeaveAllotmentComponent extends BaseComponent implements OnInit {
  table: Array<any> = [];
  headingName: any = {};
  workItemId: any;
  labelName: any = {};
  constructor(private fb: FormBuilder, private active: ActivatedRoute,  CommonService: CommonService,  toastr: ToastrService) {
    super(CommonService, toastr);
    this.active.params.subscribe(res => {
      this.workItemId = res.id
    })
    this.load();
    this.loadHeadings();
    this.getLabels();
  }

  ngOnInit(): void {
  }

  activiceSpinner() {
    this.CommonService.activateSpinner();
  }
  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(`EmsDynamicheadingLables/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.headingName = res;
    })
  }

  getLabels() {
    this.labelName = {};
    this.CommonService.getCall(`TenantRegistration/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.labelName = res;
    })
  }
  load() {
    this.activiceSpinner();
    this.CommonService.postCall(`EmsLeaveManagement/StaffLeaveReports`, {}).subscribe((res: any) => {
      this.table = [];
      setTimeout(() => {
        this.table = res;
      }, 10)
      this.deactivateSpinner();
    }, e => { this.deactivateSpinner(), console.log(e) })
  }


  changeStatus(lId: any, status: string) {
    let payload = {
      "leavetypes_id": lId,
      "leavetypes_status": status
    }
    if (confirm(`Are you sure you want to ${status} the leave?`)) {
      this.CommonService.getCall(`EmsLeaveManagement/UpdateLeaveStatus/${lId}/${status}`).subscribe((res: any) => {
        this.load();
        this.toastr.success(`Leave ${status} Successfully`);
      })
    }
  }


}
